import FilePickerErrorMessageViewState from '../../store/schema/FilePickerErrorMessageViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('hideFilePickerErrorMessage')(function hideFilePickerErrorMessage(
    viewState: FilePickerErrorMessageViewState
) {
    viewState.isShown = false;
});
